import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "mb-6" }
const _hoisted_3 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_4 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_5 = { class: "flex justify-between items-center" }
const _hoisted_6 = { class: "flex flex-end mb-1" }
const _hoisted_7 = { class: "pt-3 bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg" }
const _hoisted_8 = { class: "flex items-center flex-col gap-2 my-2" }
const _hoisted_9 = { class: "w-full" }
const _hoisted_10 = ["textContent"]
const _hoisted_11 = { class: "w-full" }
const _hoisted_12 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReturnConfirmModal = _resolveComponent("ReturnConfirmModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "font-bold break-all leading-tight text-2xl mt-0 mr-2" }, "FAQ", -1)),
              _createElementVNode("div", _hoisted_6, [
                (_ctx.can_edit_membership_details)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.update()), ["prevent"])),
                      class: "tracking-widest cursor-pointer bg-white py-2 px-4 rounded text-theme-green hover:bg-theme-darkgreen hover:text-white mr-3"
                    }, " SAVE "))
                  : _createCommentVNode("", true),
                (_ctx.can_edit_membership_details)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openDeleteConfirmModal()), ["prevent"])),
                      class: "cursor-pointer rounded-md bg-white text-theme-red py-2 px-4 hover:bg-theme-darkgreen hover:text-white mr-3"
                    }, "DELETE"))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
                  class: "cursor-pointer rounded-md text-white py-2 hover:opacity-70"
                }, "CLOSE")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper ' + (_ctx.form.question.error_type))
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Question", -1)),
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Input Your Question Here",
                    onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.validateFields(['question']))),
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.question.value) = $event)),
                    class: "block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm",
                    type: "text"
                  }, null, 544), [
                    [_vModelText, _ctx.form.question.value]
                  ]),
                  (_ctx.form.question.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.question.error_message)
                      }, null, 8, _hoisted_10))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", {
                  class: _normalizeClass('input-wrapper ' + (_ctx.form.answer.error_type))
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("label", { class: "text-xs tracking-[0.4px]" }, "Answer", -1)),
                  _withDirectives(_createElementVNode("textarea", {
                    placeholder: "Input Your Answer Here",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.answer.value) = $event)),
                    onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.validateFields(['answer']))),
                    class: "block tracking-wider border-none rounded placeholder-theme-878686 bg-gray-black w-full text-sm"
                  }, null, 544), [
                    [_vModelText, _ctx.form.answer.value]
                  ]),
                  (_ctx.form.answer.error_message)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "field-error label-text mt-1",
                        textContent: _toDisplayString(_ctx.form.answer.error_message)
                      }, null, 8, _hoisted_12))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.deleteObj.modal)
      ? (_openBlock(), _createBlock(_component_ReturnConfirmModal, {
          key: 0,
          closeClick: _ctx.closeDeleteModal,
          actionClick: _ctx.deleteFaq,
          obj: _ctx.deleteObj.obj,
          heading: 'You Are About To Delete an FAQ'
        }, null, 8, ["closeClick", "actionClick", "obj"]))
      : _createCommentVNode("", true)
  ], 64))
}